<template>
  	<div>

    	<multiselect
			v-model="OPZIONE_SELEZIONATA"
			:track-by="'id'"
			:value="'Integer'"
			:placeholder="placeholder"
			open-direction="bottom"
			:options="opzioniVisibili"
			@select="formattaInUscita"
			:multiple="false"
			:searchable="true"
			:internal-search="true"
			label="text"
			:clear-on-select="false"
			:close-on-select="true"
			:options-limit="300"
			:limit="3"
			:max-height="200"
			:show-no-results="true"
			:hide-selected="true"
			:selectLabel="''"
			:disabled="disabled"
		>
			<template v-slot:clear >
				<div class="multiselect__clear" v-if=" this.currentId > 0" @mousedown.prevent.stop="clearAll()"></div>
			</template>
			<template v-slot:noResult >Nessun risultato</template>

		</multiselect>
  	</div>
</template>


<script>
import { computed } from 'vue'
import Multiselect from 'vue-multiselect'
import { utils } from '../../assets/js/utils';


export default {
	name: 'Select2Locale',

	components:{
		Multiselect
	},

	data() {
		return {
			currentId:0
		};
	},

  	emits: ['update:modelValue','selectedItem'],

  	setup(props, { emit }) {

		const OPZIONE_SELEZIONATA = computed({
			get: () => {
				var t = props.modelValue;
				if (t == undefined || t == null || t == 0 || t == ''){
					return {id: 0,text: props.placeholder || 'Selezionare un elemento'};
				}
				var item = utils.array.select(props.options,"id",t,1)[0];
				if (item != undefined){
					return item;
				}
				return {id: 0,text:'Selezionare un elemento'};
			},
			set : (newVal) => {
				if (newVal == null || newVal.hasOwnProperty("id") == false){
					emit('selectedItem',newVal);
					return newVal;
				}
				emit('selectedItem',newVal.id);
				return newVal;
			}
		});
		return { OPZIONE_SELEZIONATA };
  	},

	props: {
		modelValue: [String, Number],
		options:{
			type:Array,
			default: () => []
		},
		placeholder: {
			type: String,
			default: ''
		},
		disabled:{
			type : Boolean,
			default : false
		},
		// Opzionale: mostra solo le opzioni con FLG_ATTIVO = 1.
		// Default false = comportamento storico invariato.
		soloAttivi: {
			type: Boolean,
			default: false
		},
	},

	computed: {
		opzioniVisibili() {
			if (!this.soloAttivi) return this.options;
			const opzioni = Array.isArray(this.options) ? this.options : [];
			return opzioni.filter(opzione => {
				// Le opzioni senza indicatore di attività restano visibili:
				// non si esclude un dato che non possiede il campo.
				if (!opzione || !Object.prototype.hasOwnProperty.call(opzione, 'FLG_ATTIVO')) return true;
				const attivo = opzione.FLG_ATTIVO;
				return attivo === null || attivo === undefined || attivo === '' || Number(attivo) === 1;
			});
		},
	},

  	methods: {
		formattaInUscita(selectedOption){
			if (selectedOption != undefined && selectedOption.hasOwnProperty("id")){
				this.$emit('update:modelValue',selectedOption.id);
				this.currentId = selectedOption.id;
			}
    	},
		clearAll:function(){
			this.currentId = 0;
			this.$emit('update:modelValue',0);
		},
	},
};
</script>

<style scoped>
:deep(.multiselect__content-wrapper) {
	overflow-y: scroll;
	overflow-x: hidden;
	scrollbar-width: thin;
	scrollbar-color: #629991 #f1f1f1;
}
</style>